import { IAPIErrorResponse } from "../../Data/Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IResponseCompra } from "../../Data/Interfaces/Responses/Compra/IResponseCompra";
import { createAction, Action, ActionsUnion } from "../../Utils/actionHelpers";

export enum CompraActionKeys {
  SAVE_COMPRA_SUCCESS = "SAVE_COMPRA_SUCCESS",
  SAVE_COMPRA_FAILED = "SAVE_COMPRA_FAILED",

  SET_LOADING = "SET_LOADING",
}

export const CompraActions = {
  saveComprasSuccess: (
    data: IResponse<IResponseCompra>
  ): SaveCompraSuccessAction =>
    createAction(CompraActionKeys.SAVE_COMPRA_SUCCESS, data),
  saveComprasFailed: (data: IAPIErrorResponse): SaveCompraFailedAction =>
    createAction(CompraActionKeys.SAVE_COMPRA_FAILED, data),

  setLoading: (isLoading: boolean): StartLoadingAction =>
    createAction(CompraActionKeys.SET_LOADING, isLoading),
};

export type CompraActionUnion = ActionsUnion<typeof CompraActions>;

export type SaveCompraSuccessAction = Action<
  CompraActionKeys.SAVE_COMPRA_SUCCESS,
  IResponse<IResponseCompra>
>;

export type SaveCompraFailedAction = Action<
  CompraActionKeys.SAVE_COMPRA_FAILED,
  IAPIErrorResponse
>;

export type StartLoadingAction = Action<CompraActionKeys.SET_LOADING, boolean>;
